module.exports = __webpack_public_path__ + "img/访客管理.a7341106.svg";